import styled from 'styled-components';
import { colors, fonts, metrics } from '@/theme';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: solid 1px ${colors.black};
  padding-top: 15px;
  @media (max-width: ${metrics.mobile}px) {
    flex-direction: column;
  }
`;

export const Box = styled.div`
  width: 30%;
  @media (max-width: ${metrics.mobile}px) {
    width: 100%;
  }
`;

export const Title = styled.h2`
  ${fonts.getSubTitle()}
  @media (max-width: ${metrics.mobile}px) {
    ${fonts.getRegularText(true)}
    margin: 10px 0 0 0;
  }
`;
